<script>
import { globalStore } from "./main";
import { SCORM } from "pipwerks-scorm-api-wrapper";
import { eventBus } from "./main";
export default {
  name: "app",
  data() {
    return {
      balance: {},
      currentPage: "",
      finished: false,
      fixed_income: 0,
      lastPage: "",
      passingScore: 70,
      progress: 0,
      responses: {},
      result: 2,
      results: {},
      score: 0,
      basePage: 'P_',
      startPage: 'P_1',
      suspend_data: {},
      transitionName: "slide",
      variable_income: 0,
      enlace: "https://www.bbva.mx/personas/productos/creditos/prestamos-personales/prestamo-personal-inmediato.html"
    };
  },
  methods: {
    FormatChoiceResponse(value) {
      var newValue = new String(value);
      newValue = newValue.replace(/\W/g, "_");
      return newValue;
    },
    RecordQuestion(
      id,
      questionText,
      questionType,
      learnerResponse,
      correctAnswer,
      wasCorrect,
      objectiveId
    ) {
      var nextIndex = SCORM.get("cmi.interactions._count", true);
      SCORM.set("cmi.interactions." + nextIndex + ".id", id);
      SCORM.set("cmi.interactions." + nextIndex + ".description", questionText);
      SCORM.set(
        "cmi.interactions." + nextIndex + ".objectives.0.id",
        objectiveId
      );
      SCORM.set("cmi.interactions." + nextIndex + ".type", questionType);

      if (questionType == "choice") {
        learnerResponse = this.FormatChoiceResponse(learnerResponse);
        correctAnswer = this.FormatChoiceResponse(correctAnswer);
      }
      if (learnerResponse != "") {
        SCORM.set(
          "cmi.interactions." + nextIndex + ".learner_response",
          learnerResponse
        );
      }
      SCORM.set(
        "cmi.interactions." + nextIndex + ".correct_responses.0.pattern",
        correctAnswer
      );
      if (wasCorrect == true) {
        SCORM.set("cmi.interactions." + nextIndex + ".result", "correct");
      } else {
        SCORM.set("cmi.interactions." + nextIndex + ".result", "incorrect");
      }
      objectiveQuestionCount[objectiveId]++;
      if (wasCorrect == true) {
        objectiveCorrectCount[objectiveId]++;
      }
    },
    RecordScore(score) {
      SCORM.set("cmi.core.score.raw", this.score);
      SCORM.set("cmi.core.score.min", "0");
      SCORM.set("cmi.core.score.max", "100");
      if (this.score >= this.passingScore) {
        SCORM.set("cmi.core.lesson_status", "passed");
      } else {
        SCORM.set("cmi.core.lesson_status", "failed");
      }
    },
    setProgress(value) {
      SCORM.set("cmi.core.lesson_location", value);
      SCORM.save();
      SCORM.quit();
    },
    exitHandler() {
      if (!finished) {
        Alert("finished");
        SCORM.set("cmi.core.exit", "suspend");
      }
    }
  },
  created() {
    globalStore.basePage = this.basePage;
    document.addEventListener("beforeunload", this.exitHandler);
    eventBus.$on("next_page", page => {
      this.transitionName = "slide";
      this.currentPage = page;
      //save the current location as the bookmark
      SCORM.set("cmi.core.lesson_location", this.currentPage);
      SCORM.set("cmi.suspend_data", JSON.stringify(this.suspend_data));
      SCORM.save();
    });
    eventBus.$on("last_page", page => {
      this.transitionName = "slide-back";
      this.currentPage = page;
      //save the current location as the bookmark
      SCORM.set("cmi.core.lesson_location", this.currentPage);
      SCORM.save();
    });
    eventBus.$on("next_chapter", page => {
      this.transitionName = "scroll";
      this.currentPage = page;
      //save the current location as the bookmark
      SCORM.set("cmi.core.lesson_location", this.currentPage);
      SCORM.save();
    });
    eventBus.$on("send_result", result => {
      this.results[this.currentPage] = result;
    });
    eventBus.$on("send_suspend_data", suspend_data => {
      this.suspend_data[this.currentPage] = suspend_data;
    });
    eventBus.$on("record_score", result => {
      this.score = result;
      this.RecordScore(this.score);
      console.log("Record score: " + this.score);
    });
    eventBus.$on("finish", result => {
      SCORM.set("cmi.core.lesson_status", "completed");
      SCORM.save();
      SCORM.quit();
    });
    //Funciones SCORM
    /*SCORM.init();
    SCORM.set("cmi.core.lesson_mode", "normal");
    SCORM.save();*/
    var completionStatus = SCORM.get("cmi.core.lesson_status");
    if (completionStatus == "not attempted") {
      SCORM.set("cmi.core.lesson_status", "incomplete");
      SCORM.save();
    }
    this.currentPage = SCORM.get("cmi.core.lesson_location");
    if (this.currentPage.includes("page")) {
      console.log("recuperando progreso");
      this.suspend_data = JSON.parse(SCORM.get("cmi.suspend_data"));
    } else {
      this.currentPage = this.startPage;
      console.log("iniciando progreso");
    }
  }
};
</script>

<template>
  <div id="app">
    <transition :name="transitionName" mode="out-in">
      <keep-alive>
        <component id="component" v-bind:is="currentPage"></component>
      </keep-alive>
    </transition>
  </div>
</template>

<style lang="scss">
.slide-enter-active {
  transition: transform 1s;
}

.slide-leave-active {
  transition: transform 1s;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(-100%);
}

.slide-back-enter-active {
  transition: transform 1s;
}

.slide-back-leave-active {
  transition: transform 1s;
}

.slide-back-enter {
  transform: translateX(-100%);
}

.slide-back-leave-to {
  transform: translateX(100%);
}

.scroll-enter-active {
  transition: transform 3.5s;
}

.scroll-leave-active {
  transition: transform 1.5s;
}

.scroll-enter {
  transform: translateY(200%);
}

.scroll-leave-to {
  transform: translateY(-100%);
}

.scroll-slide-enter-active {
  transition: transform 1s;
}

.scroll-slide-leave-active {
  transition: transform 0.5s;
}

.scroll-slide-enter {
  transform: translateY(200%);
}

.scroll-slide-leave-to {
  transform: translateX(-100%);
}

.slide-scroll-enter-active {
  transition: transform 1s;
}

.slide-scroll-leave-active {
  transition: transform 0.5s;
}

.slide-scroll-enter {
  transform: translateY(200%);
}

.slide-scroll-leave-to {
  transform: translateX(-100%);
}
</style>
